import { isArray } from '@/utils/is';
import { useUserStore } from '@/store/user';

export const vRole = {
  inserted(el, binding) {
    let hasRole = true;
    const userStore = useUserStore();
    const { value: roles } = binding;
    // 获取指令修饰符
    // every 为严格匹配
    const { every } = binding.modifiers;
    if (isArray(roles)) {
      hasRole = userStore.roles[every ? 'every' : 'some'](role => roles.includes(role));
    } else {
      hasRole = userStore.roles.includes(roles);
    }
    if (!hasRole) el.parentNode.removeChild(el);
  }
};

export default vRole;
